module.exports = __webpack_public_path__ + "img/sharing.9cf71056.svg";